import { useMutation, useQueryClient } from '@tanstack/react-query';
import { strapiUpdateManagedUser } from '../../api/strapiUsers';
import { queryKeys } from '../queryKeys';

export function useUpdateManagedUserMutation(jwt: string | null) {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: ({
      id,
      ...patch
    }: {
      id: string;
      username?: string;
      blocked?: boolean;
      password?: string | null;
      userTypeId?: string;
      analisTypeDataIds?: string[];
    }) => {
      if (!jwt) throw new Error('Not signed in');
      return strapiUpdateManagedUser(jwt, id, patch);
    },
    onSuccess: async (_, vars) => {
      await qc.invalidateQueries({ queryKey: [...queryKeys.strapi, 'users'] });
      await qc.invalidateQueries({ queryKey: queryKeys.userDetail(jwt, vars.id) });
    },
  });
}
